<template>
  <b-modal
    id="productDetailModal"
    :title="product ? product.name : ''"
    size="lg"
    hide-footer
    @hidden="$emit('closed')"
  >
    <div v-if="product">
      <b-row>
        <!-- Image Carousel -->
        <b-col cols="12" md="6">
          <div v-if="images.length > 0">
            <b-carousel
              controls
              indicators
              :interval="0"
              style="background: #f8f9fa; border-radius: 8px;"
            >
              <b-carousel-slide
                v-for="image in images"
                :key="image.id"
              >
                <template #img>
                  <img
                    :src="image.public_url"
                    :alt="image.original_filename || 'Product image'"
                    style="height: 300px; width: 100%; object-fit: contain;"
                    class="d-block"
                  />
                </template>
              </b-carousel-slide>
            </b-carousel>
          </div>
          <div v-else-if="product.public_img_src && product.public_img_src.length > 5">
            <img
              :src="product.public_img_src"
              :alt="product.name"
              style="height: 300px; width: 100%; object-fit: contain; border-radius: 8px; background: #f8f9fa;"
              class="d-block"
            />
          </div>
          <div v-else class="text-center py-5 text-muted" style="background: #f8f9fa; border-radius: 8px;">
            <i class="mdi mdi-image-outline" style="font-size: 48px;"></i>
            <p>No images</p>
          </div>
        </b-col>

        <!-- Product Info -->
        <b-col cols="12" md="6">
          <h5 class="mb-3">
            <b>{{ formattedPrice }}</b>
          </h5>
          <stock-badge
            :quantity="product.stock_quantity || 0"
            :low-threshold="product.low_stock_threshold || 5"
          />

          <!-- Description -->
          <div v-if="product.description" class="mt-3">
            <div class="product-description" v-html="product.description"></div>
          </div>

          <!-- Action Button -->
          <div class="mt-4">
            <b-button
              variant="primary"
              block
              :disabled="isOutOfStock"
              @click="$emit('add-product', product)"
            >
              <span v-if="isOutOfStock">Out of Stock</span>
              <span v-else>{{ actionLabel }}</span>
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import StockBadge from "@/components/shared/stockBadge";

export default {
  name: "productDetailModal",
  components: { StockBadge },
  props: {
    product: { type: Object, default: null },
    actionLabel: { type: String, default: "Add to Order" },
  },
  computed: {
    images() {
      return this.product && this.product.images ? this.product.images : [];
    },
    isOutOfStock() {
      return this.product ? (this.product.stock_quantity || 0) === 0 : true;
    },
    formattedPrice() {
      if (!this.product) return "";
      const price = parseFloat(this.product.price) || 0;
      return `R${price.toFixed(2)}`;
    },
  },
};
</script>

<style scoped>
.product-description {
  line-height: 1.6;
  word-wrap: break-word;
}
.product-description >>> img {
  max-width: 100%;
  height: auto;
}
</style>
